import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import { sxs } from '@qualifio/ui-commons';

export function Title({
  children,
  className,
  sx = {},
}: {
  children: React.ReactNode;
  className?: string;
  sx?: SxProps;
}): React.ReactElement {
  return (
    <Typography
      className={className}
      sx={sxs(
        {
          fontSize: 20,
          marginBottom: 1,
        },
        sx,
      )}
      variant="h2"
    >
      {children}
      <br />
      <Box
        component="span"
        sx={{
          backgroundColor: ({ palette }) => palette.primary.main,
          height: 2,
          margin: [1, 0, 0],
          width: 40,
          display: 'inline-block',
        }}
      />
    </Typography>
  );
}
